module.exports = __webpack_public_path__ + "static/media/ae.6d497f1c.svg";